import cn from "@/v2-ui/utils/utils.cn"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
import AgentConversationTable from "@/v2-backoffice-client/agentConversation/AgentConversationTable"

export type AgentConversationPageProps = PageProps

function AgentConversationPage(props: AgentConversationPageProps) {
  const { className, ...pageProps } = props

  return (
    <Page className={cn("agent-conversation-page", className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Agent Conversations</Page.Title>
      </Page.Header>

      <Page.Content className="flex-1 min-h-0 overflow-auto">
        <AgentConversationTable />
      </Page.Content>
    </Page>
  )
}

export default AgentConversationPage
